import { render, staticRenderFns } from "./LECO_WishList.vue?vue&type=template&id=522d95ea&scoped=true&"
import script from "./LECO_WishList.vue?vue&type=script&lang=js&"
export * from "./LECO_WishList.vue?vue&type=script&lang=js&"
import style0 from "./LECO_WishList.vue?vue&type=style&index=0&id=522d95ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522d95ea",
  null
  
)

export default component.exports